module.exports = __webpack_public_path__ + "img/range3.4c8178ca.png";